export default {
  methods: {
    setPageHaveChange () {
      localStorage.setItem('newContent', true)
    },
    checkPageHaveChange () {
      if (localStorage.newContent) {
        return true
      } else {
        return false
      }
    },
    customRouteBack (route) {
      if (route && this.$route.name === route.name) {
        return false
      }
      if (history.state.newContent) {
        this.setPageHaveChange()
        /*if (route) {
          this.$router.push(route)
        } else {
          window.history.back()
        }*/
      }
      if (history.length > 2) {
        window.history.back()
      } else if (route) {
        this.$router.push(route)
      } else {
        window.history.back()
      }
    }
  }
}
